<template>
  <div style="width: 100%;height: 100%;">
    <div class="swiper-list-container" v-if="tableData.length > 0">


      <div class="list-title">
        <div class="title" :class="item.name == '名称' ? 'title flxe_item' : 'title'" v-for="(item, index) in tableColumn"
          :key="index" :style="{ width: `${14.28}%` }">
          <div style="display: flex;align-items: center;height: 100%;">
            <div class="title-name">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>





      <div class="slider-container">
        <div v-for="(item, index) in showData" :key="index" class="list-line slider-item">

          <div v-for="(val, i) in tableColumn" :key="val.key" :style="{ width: `${14.28}%` }"
            :class="val.key == '名称' ? 'item flxe_item' : 'item'">
            <div style="display: flex;align-items: center;height: 100%;text-align: center;justify-content: center;">
              {{ item[val.key]==0?'-':item[val.key] }}
            </div>
          </div>


        </div>
      </div>



      <div class="collect-title">
        <div :class="item == '总面积' ? 'title flxe_item' : 'title'" v-for="(item, index) in tableCollect" :key="index"
          :style="{ width: `${14.28}%` }">
          <div style="display: flex;align-items: center;height: 100%;">
            <div class="title-name">
              {{ item==0?'-':item }}
            </div>
          </div>
        </div>
      </div>



    </div>
  </div>
</template>

<script>
// 引入js
import Swiper from "swiper";
// 引入css
import "swiper/css/swiper.min.css";
let currentIndex = 0; // 当前显示的div索引
const contents = document.querySelectorAll('.content'); // 获取所有内容divs
const totalContents = contents.length; // 内容总数
const intervalTime = 3000; // 自动切换间隔时间（毫秒）




export default {
  name: "HelloWorld",
  props: {
    // 列标题
    tableColumn: {
      type: Array,
      default: () => [

      ],
    },
    // 数据
    tableData: {
      type: Array,
      default: () => [

      ],

    },
    // 数据
    tableCollect: {
      type: Array,
      default: () => [

      ],
    },
  },



  data() {
    return {
      swiper: null,
      swipers: null,
      aaa: null,
      // 列标题
      column: [
        { title: '姓名', key: 'name', width: 100 },
        { title: '年龄', key: 'age', width: 100 },
        { title: '性别', key: 'sex', width: 100 },
      ],
      // 数据
      data: [
        { name: 'Nicholas', age: '18', sex: '男' },
        { name: 'Hetty', age: '18', sex: '男' },
        { name: 'Graham', age: '18', sex: '女' },
        { name: 'Harley', age: '18', sex: '男' },
        { name: 'Finbar', age: '18', sex: '女' },
        { name: 'Oliver', age: '18', sex: '男' },
      ],
      currentIndex: 0,
      intervalTime: 3000,
      contents: [],
      totalContents: 0,
      showData: [],
      interval: null



    }

  },
  methods: {

    showNextContent() {
      console.log(this.contents)
      this.contents[this.currentIndex].style.opacity = 0; // 当前内容透明度设为0
      this.currentIndex = (this.currentIndex + 1) % this.totalContents; // 更新索引，循环显示内容
      this.contents[this.currentIndex].style.opacity = 1; // 下一个内容透明度设为1，显示出来
    },
    createSwiper() {
      this.swipers = new Swiper('.swiper-container', {

        // 衔接滑动
        loop: true,

        // 自动滑动
        autoplay: {
          autoplay: true,
          delay: 300000,
          // 如果设置为true，当切换到最后一个slide时停止自动切换。
          // stopOnLastSlide: false,
          // 如果设置为false，用户操作swiper之后自动切换不会停止，每次都会重新启动autoplay
          disableOnInteraction: false
        },
        // 切换效果 "coverflow"（3d流）
        // effect: 'coverflow',
        // 设置slider容器能够同时显示的slides数量
        slidesPerView: 4,
        // spaceBetween: "2%",
        // 居中幻灯片。设定为true时，当前的active slide 会居中，而不是默认状态下的居左。
        // centeredSlides: true,
        // 设置为true则点击slide会过渡到这个slide。
        slideToClickedSlide: true,
        coverflowEffect: {
          // slide做3d旋转时Y轴的旋转角度
          // rotate: 0,
          // 每个slide之间的拉伸值，越大slide靠得越紧。5.3.6 后可使用%百分比
          // stretch: 0,
          // slide的位置深度。值越大z轴距离越远，看起来越小。
          // depth: 60,
          // depth和rotate和stretch的倍率，相当于depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显。
          // modifier: 5,
          // 是否开启slide阴影
          // slideShadows: true
        },
        // 使用前进后退按钮来控制Swiper切换。
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        // observer: true,
        // observeParents: true,
        direction: 'vertical',

        // height: 150,
        // speed: 200, // 匀速时间
        //             autoplay: {
        //   autoplay: true,
        //   delay: 300,
        //   // 如果设置为true，当切换到最后一个slide时停止自动切换。
        //   // stopOnLastSlide: false,
        //   // 如果设置为false，用户操作swiper之后自动切换不会停止，每次都会重新启动autoplay
        //   disableOnInteraction: false
        // },
        //                 autoplay: {
        //                     delay: 0,
        //                     stopOnLastSlide: false,
        //                     disableOnInteraction: false,
        //                 },
        //                 freeMode: true,
        //                 loop: true,
        //                 direction: 'vertical',
        //                 slidesPerView: 'auto',
        //                 observer:true,
        // observeParents:true,
      });
    },
    init() {
      if (!this.swipers) {
        console.log(33)
        this.createSwiper();
      } else if ((this.swipers.passedParams.loop === true && this.data.length <= 5)
        || (this.swipers.passedParams.loop === false && this.swipers.listData.length > 5)) {
        console.log(111)
        this.swipers.destroy();
        this.swipers = null;
        setTimeout(() => {
          createSwiper();
        }, 0);
      } else {
        console.log(222)
        this.swipers.update();
      }
    },
  },
  mounted() {
    // document.addEventListener('DOMContentLoaded', function () {
    // console.log("1111111", this.tableColumn)

    const items = document.querySelectorAll('.slider-item');
    // console.log("2222221", this.tableData)
    let currentIndex = 0; // 当前显示的起始索引
    const visibleCount = 4; // 每次显示的`div`数量
    const totalItems = items.length; // 总项目数
    // for (let i = 0; i < visibleCount; i++) {
    //   items[i].style.display = 'block';
    // }
    this.showData = [this.tableData[0], this.tableData[1], this.tableData[2], this.tableData[3]]
    let indexArr = []

    const that = this
    function showNextItems() {
      // 隐藏所有项目
      console.log("222222", that.tableData)
      // items.forEach(item => item.style.display = 'none');
      // 计算下一个要显示的项目起始索引和结束索引

      let index1 = currentIndex + 1 > that.tableData.length - 1 ? 0 : currentIndex + 1;
      let index2 = index1 + 1 > that.tableData.length - 1 ? 0 : index1 + 1
      let index3 = index2 + 1 > that.tableData.length - 1 ? 0 : index2 + 1
      let index4 = index3 + 1 > that.tableData.length - 1 ? 0 : index3 + 1

      console.log(index1, index2, index3, index4, currentIndex, index4)

      // items[currentIndex].style.display = 'none';
      // items[index4].style.display = 'block';
      currentIndex = currentIndex + 1 > that.tableData.length - 1 ? 0 : currentIndex + 1
      // this.$nextTick(() => {

      // })
      that.showData = [that.tableData[index1], that.tableData[index2], that.tableData[index3], that.tableData[index4]]
    }

    // 每3秒切换一次项目（3000毫秒）
    this.interval = setInterval(showNextItems, 3000);
    // });
    // this.$nextTick(() => {
    // const element = this.$refs.myElement;
    // console.log(element.offsetWidth); // 获取宽度
    // this.contents = document.querySelectorAll('.content');
    // this.totalContents = this.contents.length; // 内容总数


    // });


    // this.swiper = new Swiper(".swiper", {
    //   direction: "vertical", // 垂直切换选项
    //   loop: true, // 循环模式选项

    //   // 如果需要分页器
    //   pagination: {
    //     el: ".swiper-pagination",
    //   },

    //   // 如果需要前进后退按钮
    //   navigation: {
    //     nextEl: ".swiper-button-next",
    //     prevEl: ".swiper-button-prev",
    //   },
    //   on: {

    //       resize: () => {
    //         this.swiper.params.height = document.documentElement.offsetHeight;
    //         this.swiper.update(true);
    //       }
    //     }



    // });

    // this.swipers = null
    // this.init();

    // setInterval(this.showNextContent, this.intervalTime); // 设置定时器自动切换内容
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }

  }
};
</script>

<style lang="scss" scoped>
/* 滚动条样式 */
// .table-container::-webkit-scrollbar {
//     width: 14px;
//     height: 14px;
// }

// .table-container::-webkit-scrollbar-track {
//     background: #f1f1f1;
//     border-radius: 10px;
// }

// .table-container::-webkit-scrollbar-thumb {
//     background: linear-gradient(45deg, #6a11cb, #2575fc);
//     border-radius: 10px;
//     border: 3px solid #f1f1f1;
// }

// .table-container::-webkit-scrollbar-thumb:hover {
//     background: linear-gradient(45deg, #4a00e0, #0072ff);
// }


.flxe_item {
  position: sticky;
  left: 0;

  // background-color: rgba(14, 45, 40, 1) !important;
  // background: linear-gradient(to right, #34495e, #2c3e50);
  // color: white;
  // font-weight: 600;
  z-index: 15;
  // border-right: 2px solid #1a2a38;
  // box-shadow: 4px 0 8px rgba(0, 0, 0, 0.1);
  // min-width: 180px;
  // flex: 0 0 180px;
}





.swiper-list-container {
  position: relative;
  width: 100%;
  height: 100%;
  // height: calc(100% - 15px);
  overflow-x: auto;
  overflow-y: hidden;

  // &::-webkit-scrollbar {
  //     display: none;
  //   }
  &::-webkit-scrollbar-track-piece {
    background: #c1c1c1;
  }

  &::-webkit-scrollbar {
    width: 2px !important;
    height: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background: #f1f1f1;
    // border-radius: 20px;
  }

  .list-title {
    // display: flex;
    // justify-content: flex-start;
    width: 100%;
    height: 17.5%;
    color: #fff;
    // position: absolute;
    // top: 0;
    // left: 0;


    // overflow-x: auto;
    &::-webkit-scrollbar {
      display: none;
    }

    white-space: nowrap;

    .title {
      display: inline-block;
      align-items: center;
      height: 100%;
      background-color: rgba(14, 45, 40, 0.8);
      // background-color: blue;
      // border-right: 1px solid;
    }

    .title-name {
      width: 100%;
      overflow: hidden;
      // line-height: 30px;
      text-align: center;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 0.8vw;
      font-weight: 800;
    }
  }

  .slider-container {
    // overflow: hidden;
    /* 隐藏超出容器的部分 */
    position: relative;
    height: 66.5% !important;
    /* 为绝对定位提供参考 */
    display: flex;
    flex-direction: column;

    .list-line {
      // display: flex;
      // flex-direction: row;
      // justify-content: flex-start;
      height: 100% !important;
      // // line-height: 150px !important;
      color: #ffffffe8;
      // align-items: center;

      width: 100%;

      // height: 17.5%;
      // color: #fff;
      // background-color: rgba(14, 45, 40, 0.8);
      // overflow-x: auto;
      &::-webkit-scrollbar {
        display: none;
      }

      position: relative;

      white-space: nowrap;

      .item {
        background-color: rgba(14, 45, 40, 0.59);
        display: inline-block;
        overflow: hidden;
        text-align: center;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 0.7vw;
        height: 100%;

      }

      .flxe_item {
        // position: absolute;
        // top: 0;
        // left: 0;
        // position: fixed;

      }

      .swiper-wrapper {
        // flex-direction: column;
      }
    }
  }

  .collect-title {
    // display: flex;
    // justify-content: flex-start;
    width: 100%;
    height: 17%;
    color: #fff;



    // overflow-x: auto;
    &::-webkit-scrollbar {
      display: none;
    }

    white-space: nowrap;

    .title {
      background-color: rgba(14, 45, 40, 0.59);
      display: inline-block;
      align-items: center;
      height: 100%;
      overflow: hidden;
    }

    .title-name {
      width: 100%;
      overflow: hidden;
      // line-height: 30px;
      text-align: center;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 0.7vw;
      font-weight: 600;
    }
  }


}
</style>